import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext.jsx";
import AppLayout from "./components/layout/AppLayout.jsx";

import LoginPage          from "./pages/LoginPage.jsx";
import MfaPage             from "./pages/MfaPage.jsx";
import ResetPasswordPage  from "./pages/ResetPasswordPage.jsx";
import AdminDashboardPage from "./pages/AdminDashboardPage.jsx";
import TicketsPage        from "./pages/TicketsPage.jsx";
import TicketDetailPage   from "./pages/TicketDetailPage.jsx";
import ClientsPage        from "./pages/ClientsPage.jsx";
import ClientDetailPage   from "./pages/ClientDetailPage.jsx";
import UsersPage          from "./pages/UsersPage.jsx";
import AssetsPage         from "./pages/AssetsPage.jsx";
import AssetDetailPage    from "./pages/AssetDetailPage.jsx";
import InventoryPage      from "./pages/InventoryPage.jsx";
import ReportsPage        from "./pages/ReportsPage.jsx";
import BillingPage        from "./pages/BillingPage-admin.jsx";
import SyncPage           from "./pages/SyncPage.jsx";
import MonitoringPage     from "./pages/MonitoringPage.jsx";
import SettingsPage       from "./pages/SettingsPage.jsx";
import NotificationsPage  from "./pages/NotificationsPage.jsx";
import ProfilePage        from "./pages/ProfilePage.jsx";
import PasswordsPage      from "./pages/PasswordsPage.jsx";
import MyPasswordsPage    from "./pages/MyPasswordsPage.jsx";
import AccessLogPage      from "./pages/AccessLogPage.jsx";
import VaultExportPage    from "./pages/VaultExportPage.jsx";

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login"      element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/verify-mfa" element={user ? <Navigate to="/dashboard" replace /> : <MfaPage />} />

      {/* Pas de garde sur l'état de connexion : un admin déjà connecté doit
          pouvoir ouvrir le lien d'invitation d'un AUTRE compte (ex: un
          sous-admin qu'il vient de créer) sans être redirigé vers son
          propre dashboard. */}
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route path="/" element={<PrivateRoute><AppLayout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard"     element={<AdminDashboardPage />} />
        <Route path="tickets"       element={<TicketsPage />} />
        <Route path="tickets/:id"   element={<TicketDetailPage />} />
        <Route path="clients"       element={<ClientsPage />} />
        <Route path="clients/:id"   element={<ClientDetailPage />} />
        <Route path="users"         element={<UsersPage />} />
        <Route path="assets"        element={<AssetsPage />} />
        <Route path="assets/:id"    element={<AssetDetailPage />} />
        <Route path="inventory"     element={<InventoryPage />} />
        <Route path="reports"       element={<ReportsPage />} />
        <Route path="billing"       element={<BillingPage />} />
        <Route path="sync"          element={<SyncPage />} />
        <Route path="monitoring"    element={<MonitoringPage />} />
        <Route path="settings"      element={<SettingsPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="passwords"     element={<PasswordsPage />} />
        <Route path="my-passwords"  element={<MyPasswordsPage />} />
        <Route path="access-log"    element={<AccessLogPage />} />
        <Route path="vault-export"  element={<VaultExportPage />} />
        <Route path="profile"       element={<ProfilePage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return <AuthProvider><AppRoutes /></AuthProvider>;
}